export default __webpack_public_path__ + "static/media/cut-coupon.b2047f1e.svg";